import { render, staticRenderFns } from "./SubmissionEdit.vue?vue&type=template&id=4980b1c5"
import script from "./SubmissionEdit.vue?vue&type=script&lang=js"
export * from "./SubmissionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports